
const isProductionServer = process.env.NODE_ENV === 'production'
const isDevelopmentServer = process.env.NODE_ENV === 'development'
const isLocalhostServer = window.location.href.startsWith('http://localhost')
const ServerPost = 9505
const Host = isLocalhostServer ? `http://localhost:${ServerPost}` : (isProductionServer ? 'https://www.syunkaya.com.tw' : (isDevelopmentServer ? 'https://syunkaya.wanwaninfo.com' : `http://localhost:${ServerPost}`))
// const AdminHost = isLocalhostServer ? `http://localhost:8080` : (isProductionServer ? 'https://admin.syunkaya.com.tw' : (isDevelopmentServer ? 'https://admin.syunkaya.wanwaninfo.com' : `http://localhost:8080`))

const Config = {
  WEBURL: Host,
  'firebaseRootFolderName': isProductionServer ? 'www.syunkaya.com.tw' : 'syunkaya.wanwaninfo.com',
  'jwtStorageKey': 'jwt-syunkaya.wanwaninfo.com-djaf23',
  'SaltBefore': 'ajsfdf',
  'SaltAfter': 'afnw4i',
  'languages': ['Tw', 'En', 'Jp'],
  'googleLanguageMap': {
    'Tw': 'zh-Tw',
    'Cn': 'zh-Cn',
    'En': 'en',
    'Jp': 'ja'
  },
  useFakeData: false,
  isProductInStockEnabled: true,
  // fb
  FBClientID: '', // 萬萬正資訊-後台管理系統
  FBScopePagesV9: '', // instagram_basic, pages_show_list required for IG
  FBFansPageID: '', // KPN-Test2
  FBFansPageNumID: '', // KPN-Test2
  // ig
  IGClientID: '', // 萬萬正資訊-後台管理系統
  IGScope: '',
  IGUserID: ''
}

export default Config
